import React from 'react'
import PropTypes from 'prop-types'

import { ListItemText, ListItem, ListItemAvatar, Avatar, Typography, useTheme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { ReactComponent as CalendarPlus } from 'assets/route_manager/actions_menu/CalendarPlus.svg'

import { isValidHex } from 'utils/validations'
import { extractNameInitials } from 'utils/string'
import { UNASSIGNED_ROUTE } from 'containers/new-route-manager/settings'
import { COMMON } from 'theme/colors'

const RenderOption = ({
  routeId = '',
  routeName = '',
  bgcolor = grey[100],
  stopCount = 0,
  showStopCount = true,
  primaryTypographyProps = {},
}) => {
  const theme = useTheme()
  const initials = extractNameInitials(routeName)
  const formattedBgcolor = isValidHex(bgcolor) ? bgcolor : COMMON.black
  const color = theme.palette.getContrastText(formattedBgcolor)

  return (
    <ListItemText>
      <ListItem disableGutters disablePadding>
        <ListItemAvatar sx={{ minWidth: '40px' }}>
          <Avatar sx={{ width: '32px', height: '32px', bgcolor: formattedBgcolor, color }}>
            {routeId === UNASSIGNED_ROUTE.id ? (
              <CalendarPlus width={20} height={20} color={theme.palette.action.active} />
            ) : (
              <Typography variant="h5" fontWeight={400}>
                {initials}
              </Typography>
            )}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={routeName}
          secondary={showStopCount ? `${stopCount} stop${stopCount === 1 ? '' : 's'}` : null}
          slotProps={{
            primary: { noWrap: true, color: 'textPrimary', ...primaryTypographyProps },
          }}
        />
      </ListItem>
    </ListItemText>
  )
}

RenderOption.propTypes = {
  routeId: PropTypes.string,
  routeName: PropTypes.string,
  bgcolor: PropTypes.string,
  stopCount: PropTypes.number,
  showStopCount: PropTypes.bool,
  primaryTypographyProps: PropTypes.object,
}

export default RenderOption
